var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrello(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-2 -2 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin",
    className: "jam jam-trello",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.562 0H2.438A2.435 2.435 0 0 0 0 2.432v15.087a2.435 2.435 0 0 0 2.438 2.432h15.124A2.435 2.435 0 0 0 20 17.519V2.432A2.435 2.435 0 0 0 17.562 0zM8.7 15.55a1.13 1.13 0 0 1-1.132 1.13H3.732A1.13 1.13 0 0 1 2.6 15.55V3.893c0-.624.507-1.13 1.132-1.13h3.836A1.13 1.13 0 0 1 8.7 3.893V15.55zm8.7-5.015a1.13 1.13 0 0 1-1.132 1.13h-3.836a1.13 1.13 0 0 1-1.132-1.13V3.893c0-.624.507-1.13 1.132-1.13h3.836a1.13 1.13 0 0 1 1.132 1.13v6.642z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrello);
export default __webpack_public_path__ + "static/media/trello.03795987e7b3f9208aad85c58c7353b2.svg";
export { ForwardRef as ReactComponent };